"use client";

import clsx from "clsx";
import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  label: string;
  completed: boolean;
};

/** Same row web renders for a tool call: icon, then one line of status. */
export function ToolCallRow({ icon, label, completed }: Props) {
  return (
    <div className="gail-tool-call group -ml-1.5 flex min-h-7 max-w-full items-center gap-2 rounded-md px-1.5 font-sans">
      <span
        className={clsx(
          "flex h-5 w-5 flex-shrink-0 items-center justify-center",
          completed ? "text-400" : "text-gpt-accent",
        )}
      >
        {icon}
      </span>
      <span
        title={label}
        className={clsx(
          "min-w-0 truncate text-[13px] leading-5",
          completed ? "font-normal text-500" : "font-medium text-600 animate-text-shimmer",
        )}
      >
        {label}
      </span>
    </div>
  );
}
